<template>
  <PageManager
    :iframe-target="`${link}/shops`"
    page="physical-shops"
  />
</template>

<script>

import PageManager from "@/components/SideEditor/PageManager"

import { mapGetters } from "vuex"

export default {
  components: {
    PageManager,
  },
  computed: {
    ...mapGetters({
      link: 'editor/fullDomainLink',
    }),
  },
}

</script>
